import { JSEncrypt } from 'jsencrypt'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey =
  'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJzQLou0Wz3/5ao0ysioBz7IH87RvG/1\n' +
  'HpMO7mRaK1bgH6raVsVzDJJGjkg6rrHgdYLLV08misMBbJI+DB/edGUCAwEAAQ=='

const privateKey =
  'MIIBOQIBAAJBAJzQLou0Wz3/5ao0ysioBz7IH87RvG/1HpMO7mRaK1bgH6raVsVz\n' +
  'DJJGjkg6rrHgdYLLV08misMBbJI+DB/edGUCAwEAAQJABxj0Fl4oKA76P+EqUXkr\n' +
  'dMe9itCa4Q1c4CaTmyaqogCpwpb+bd5iyzdRmxvuOYtCVzUQv19hUvIyfkC2Thb2\n' +
  'YQIhAP1iC/HLcH9GcrDI4KHV2YGx87rx06qcf10fzLO3RblhAiEAnm7NJDIPGF3g\n' +
  'hi9z044/MIiin7bU8NJ3qnmyODZuRYUCID6tCQ1XaE1jTK1kEwSVFEdbkFF2zgfO\n' +
  'zEZpvkXaGLohAiATPtBqmi4dPqIcir0eMMRaR+7BSftZ+acRrVDJ5UrF5QIgFOyr\n' +
  'uqCbWvOuW/ILJWZkaHdgVTwjcqFWBx0Uc6yJJ8A='

// 加密
export const encrypt = (txt: string) => {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export const decrypt = (txt: string) => {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}
